// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TargetFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TargetFilledIcon" ref={forwardedRef} {...props}>
      <path d="M10 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8" />
      <path d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-2 0a6 6 0 1 0-12 0 6 6 0 0 0 12 0" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const TargetFilledIcon = /* @__PURE__ */ Object.assign(
  TargetFilledIconComponent,
  { displayName: 'TargetFilledIcon' },
);
